export const PaperMenuPlaceholder = {
  extend: [
  ],
  props: {
    boxSize: '1190px 842px'
  }
}
